import { FC } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const ToastConfiguration: FC = () => {
  return <ToastContainer hideProgressBar closeButton={false} />
}

export default ToastConfiguration
